module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Tablet 1x.ae00c9ec.png";